// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3n2ko","sendOtp":"AuthorizeToLogin_sendOtp__14MwP"};